import { openExternal } from './openExternal';

/** The support address that Music24 shows to its users. It is not the FreeYourMusic address. */
export const MUSIC24_SUPPORT_EMAIL = 'support@music24.com';

export const openSupportEmail = (
  platform: string,
  appVersion: string,
  deviceId: string | undefined,
  email?: string,
  issueId?: string
) => {
  const debugInfos = [`Platform: ${platform}`, `App: ${appVersion}`, `Device ID: ${deviceId ?? ''}`];

  if (email) {
    debugInfos.push(`Account email: ${email}`);
  }

  if (issueId) {
    debugInfos.push(`Issue Identifier: ${issueId}`);
  }

  const emailBody = `\n\n\n--\nDetails for support:\n${debugInfos.join(`\n`)}`;
  const link = `mailto:${MUSIC24_SUPPORT_EMAIL}?subject=${encodeURIComponent(
    'MUSIC24 support'
  )}&body=${encodeURIComponent(emailBody)}`;
  return openExternal(link);
};
